import { Charts } from './Charts';
import HouseholdIncomeChartsDataProvider from './contexts/HouseholdIncomeChartsDataContext';

const HouseholdIncomeWrapper = () => {
    return (
        <HouseholdIncomeChartsDataProvider>
            <Charts />
        </HouseholdIncomeChartsDataProvider>
    );
};

export default HouseholdIncomeWrapper;
